/** The longest a title can be and still fit a one-third column at 12pt. */
export const TAG_TITLE_MAX_LENGTH = 24;

/**
 * The web UI caps tag chips at 160px and lets CSS ellipsize them; react-pdf has
 * no text-overflow, so the equivalent is a character count.
 */
export const truncateTagTitle = (
  title: string,
  maxLength: number = TAG_TITLE_MAX_LENGTH,
) =>
  title.length > maxLength ? `${title.slice(0, maxLength).trimEnd()}…` : title;
